import { c as _c } from "react/compiler-runtime";
import SeasonsGridDropdown from "@/components/utils/select/dropdown/SeasonsGridDropdown";
import { MemeSeason } from "@/entities/ISeason";
export default function UserPageCollectedFiltersSzn(t0) {
  const $ = _c(4);
  const {
    selected,
    initialSeasonId,
    setSelected
  } = t0;
  let t1;
  if ($[0] !== initialSeasonId || $[1] !== selected || $[2] !== setSelected) {
    t1 = <div className="tw-w-36"><SeasonsGridDropdown selected={selected} setSelected={setSelected} initialSeasonId={initialSeasonId} /></div>;
    $[0] = initialSeasonId;
    $[1] = selected;
    $[2] = setSelected;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}